export default function EmptyState({ message }: { message: string }) {
    return (
        <div className="empty-state">
            <svg
                className="empty-state__doodle"
                viewBox="0 0 160 120"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                {/* Table surface */}
                <rect x="20" y="28" width="120" height="72" rx="8" stroke="currentColor" strokeWidth="2" strokeDasharray="5 3" />

                {/* Header row */}
                <line x1="20" y1="46" x2="140" y2="46" stroke="currentColor" strokeWidth="1.5" />

                {/* Skeleton rows */}
                <path d="M32 58 Q50 56 68 58 Q86 60 104 58 Q118 56 132 58" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.35" />
                <path d="M32 70 Q44 68 62 70 Q78 72 90 70 Q106 68 118 70" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.25" />
                <path d="M32 82 Q52 80 72 82 Q88 84 108 82 Q122 80 132 82" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.15" />

                {/* Magnifying glass */}
                <circle cx="80" cy="58" r="18" fill="white" stroke="currentColor" strokeWidth="2.5" />
                <line x1="93" y1="71" x2="104" y2="82" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />

                {/* Question mark */}
                <text x="80" y="63" textAnchor="middle" fontSize="16" fontWeight="700" fill="currentColor" opacity="0.5">?</text>

                {/* Dots in header */}
                <circle cx="26" cy="37" r="2" fill="currentColor" opacity="0.3" />
                <circle cx="34" cy="37" r="2" fill="currentColor" opacity="0.3" />
                <circle cx="42" cy="37" r="2" fill="currentColor" opacity="0.3" />
            </svg>
            <p className="empty-state__text">{message}</p>
        </div>
    );
}
